// extracted by mini-css-extract-plugin
export default {"layout-title-wrapper":"Login_layout-title-wrapper__oXjoy","message-wrapper":"Login_message-wrapper__e6QMB"};